import React,{Component} from "react";
class Modal extends Component{
    closeModal = () => {
        this.props.CallBack();
    }
    hideModal = (e) => {
        if(e.target.id === 'myModal'){
            this.props.CallBack();                     
        }
    }
    render(){
        return(
            <div id="myModal" className="modal-block" onClick={(e) => this.hideModal(e)}>
                <div class="modal-block-content">
                    <span className="close" onClick={this.closeModal}>&times;</span>
                    <video controls autoPlay>
                        <source src={this.props.Url} type="video/mp4"/>
                    </video>
                </div>
            </div>
        )
    }
}
export default Modal;
